import { Icon } from '@graftcode/design-system'

import { SEARCH_MODAL_ITEM_KIND } from './modalItemKind.const'

export const ICON_MAP = {
  [SEARCH_MODAL_ITEM_KIND.QuickStart]: Icon.FastForwardRegular,
  [SEARCH_MODAL_ITEM_KIND.Glossary]: Icon.BookRegular,
  [SEARCH_MODAL_ITEM_KIND.Documentation]: Icon.DocumentRegular,
}
